import React, { ReactElement } from 'react';

import { JOURNEYS } from '../../constants/analytics.constants';
import { GlobalContextProvider } from '../../context/GlobalContext';
import Routes from '../../routes';
import * as Analytics from '../../utils/analytics';
import getLabel from '../../utils/getLabel';
import useAppConfig from '../appConfig/useAppConfig';
import AppLayout from '../appLayout/Applayout';
import BrandProvider from '../brandProvider';
import DependencyGaurd from '../dependencyGaurd/DependencyGaurd';

function App(): ReactElement {
  const brand = useAppConfig().BRAND_NAME;
  document.title = getLabel('title');
  document.getElementById('brand-icon')?.setAttribute('href', getLabel('href'));
  Analytics.setJourney(JOURNEYS.ONLINE_REGISTRATION);
  return (
    <GlobalContextProvider>
      <BrandProvider brand={brand}>
        <AppLayout>
          <DependencyGaurd>
            <Routes />
          </DependencyGaurd>
        </AppLayout>
      </BrandProvider>
    </GlobalContextProvider>
  );
}

export default App;
